<template>
  <div class="d-flex flex-column layout">
    <Header></Header>
    <div class="row collapse show no-gutters d-flex flex-grow-1 position-relative sidebar-collapse flex-nowrap">
        <div class="col-3 h-100 w-sidebar navbar-collapse collapse d-none d-lg-flex sidebar-collapse sidebar">
          <Sidebar :sidebar-links="$config.sidebar.sidebarLinks"></Sidebar>
        </div>
        <div class="col d-flex flex-column">
          <transition name="page-fade" :duration="{ enter: 260, leave: 0 }">
            <router-view></router-view>
          </transition>
        </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
  .layout {
    min-height: calc(100vh - 56px);
  }
</style>
<script>
import { Header, Sidebar } from '../components';

export default {
  components: {
    Header,
    Sidebar
  }
};
</script>